/**
 * Convierte valores de fecha de la API (ISO UTC o timestamp PG sin TZ tratado como UTC)
 * a `Date` para formateo en hora local del navegador.
 */
export function parseApiInstant(
	value: string | Date | null | undefined
): Date | null {
	if (value == null || value === '') return null;
	if (value instanceof Date) {
		return Number.isNaN(value.getTime()) ? null : value;
	}
	const s = String(value).trim();
	if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) {
		const d = new Date(s);
		return Number.isNaN(d.getTime()) ? null : d;
	}
	const pgNaive =
		/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?)$/;
	if (pgNaive.test(s)) {
		const isoUtc = (s.includes('T') ? s : s.replace(' ', 'T')) + 'Z';
		const d = new Date(isoUtc);
		return Number.isNaN(d.getTime()) ? null : d;
	}
	const d = new Date(s);
	return Number.isNaN(d.getTime()) ? null : d;
}
